var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStreaming4K = function SvgStreaming4K(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8183 27.8931C11.0146 25.224 13.2015 23.1377 15.8769 23.0625C36.6569 22.4781 48.9963 22.6731 69.0304 23.1021C71.7039 23.1593 73.9134 25.218 74.1339 27.883C75.2292 41.1167 75.477 50.1665 74.4824 63.4556C74.2914 66.0082 72.2526 68.0288 69.6999 68.2181C49.1639 69.3013 35.894 69.2409 15.1936 68.215C12.6191 68.0275 10.5683 65.9806 10.3992 63.4049C9.54537 50.3933 9.82815 41.3607 10.8183 27.8931Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4834 64.4102C10.6524 67.8737 12.6323 70.8858 15.2061 71.138C35.923 74.3512 49.1759 74.4073 69.7007 71.1422C72.2528 70.8876 74.2912 68.1704 74.4822 64.7381",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 63.4707C10.418 67.6881 12.6328 71.509 15.2067 71.7865C35.9236 75.3216 49.1764 75.3833 69.7013 71.791C72.2534 71.511 74.3015 67.4937 74.4925 63.7174",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1425 45.2832C49.7108 45.6113 49.7108 46.4316 49.1425 46.7596C45.99 48.9613 44.1348 49.9671 40.7635 51.5973C40.1952 51.9254 39.4849 51.5153 39.4849 50.8591C39.2172 47.0578 39.3339 42.7418 39.3339 41.3149C39.334 40.4197 40.0164 40.1646 40.5846 40.4927C44.0894 42.2044 45.9491 43.2671 49.1425 45.2832Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4348 45.3955C48.9176 45.6743 48.9176 46.3711 48.4348 46.6499C45.7565 48.5204 44.1804 49.3749 41.3161 50.7598C40.8333 51.0386 40.2298 50.6902 40.2298 50.1327C40.0024 46.9031 40.1016 43.2364 40.1016 42.0241C40.1016 41.2636 40.6814 41.0468 41.1642 41.3255C44.1417 42.7798 45.7217 43.6826 48.4348 45.3955Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5566 45.1552C47.2233 45.5401 47.2233 46.5024 46.5566 46.8873L42.1683 49.4209C41.5016 49.8058 40.6683 49.3247 40.6683 48.5549L40.6683 43.4877C40.6683 42.7179 41.5016 42.2367 42.1683 42.6216L46.5566 45.1552Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6807 45.1548C45.3473 45.5397 45.3473 46.5019 44.6807 46.8868L43.1055 47.7962C42.4389 48.1811 41.6055 47.7 41.6055 46.9302L41.6055 45.1114C41.6055 44.3416 42.4389 43.8605 43.1055 44.2454L44.6807 45.1548Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9307 46.0216L41.8528 46.0215",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.417 11.0977C20.7946 13.2757 21.6801 14.0731 24.2524 16.7721C25.7568 18.3505 27.1964 20.2955 29.8092 22.1007",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.146 10.3597C19.2233 11.0657 18.7137 11.7006 18.0078 11.7779C17.3018 11.8552 16.5432 11.1113 16.4659 10.4054C16.4659 9.29979 16.9433 8.96251 17.6492 8.88522C18.3552 8.80792 19.0687 9.6538 19.146 10.3597Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2168 9.46875C61.1697 11.9599 60.4052 12.8741 58.2387 15.9085C56.9716 17.683 55.8202 19.8113 53.4877 21.9665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3906 8.84085C62.4135 9.55063 63.0074 10.1075 63.7172 10.0846C64.427 10.0617 65.0733 9.21836 65.0504 8.50858C64.8947 7.414 64.3746 7.14732 63.6648 7.17022C62.955 7.19312 62.3677 8.13106 62.3906 8.84085Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStreaming4K);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "streaming4k.6c4eb9d3efe658021ceebca479e50106.svg";